import React, {Component} from 'react';
import DateTimePicker from 'date-time-picker';
import parseDateTime from './moment'
import WrapComponent from '../component/WrapComponent';

class DateIndex extends Component{
    constructor(props){
        super(props);
        
        this.state = {
            defaultValue: props.default_value?parseDateTime(props.default_value, props.date_format) : ''
        }
    }
    onChange = ()=>{
        let readonly = this.props.is_readonly
        if(readonly) return;
        this.dt && this.dt.destroy();
        this.dt = new DateTimePicker.Date({
          lang: window.sLanguageType.includes('zh') ? 'zh-CN' : 'en',
          default: this.state.defaultValue
        })
        
        this.dt.on('selected', (formatDate, now) => {
            this.setState({
                defaultValue: formatDate
            })
            this.updateFieldsValue()
        })
        this.dt.on('cleared', () => {
            this.setState({
                defaultValue: ''
            })
            this.updateFieldsValue()
        })
    }
    updateFieldsValue() {
        let defaultValue = '';
        if (this.state.defaultValue) {
            defaultValue = new Date(this.state.defaultValue.replace(/\-/g, '/') + ' 00:00').getTime()
        }
        this.props.form.setFieldsValue({
            [this.props.api_name]: defaultValue
        })
    }
    render(){
        let { api_name, form, is_required, errorText } = this.props;

        const {getFieldProps} = form;
        let defaultValue = this.state.defaultValue;
        let fieldProps = getFieldProps(api_name, {  // eslint-disable-line
            initialValue: defaultValue ? new Date(defaultValue.replace(/\-/g, '/') + ' 00:00').getTime() : null,
            validate: [{
                trigger: 'onChange',
                rules:[{
                    required: is_required,
                    message: $st(`paas.smart.form.isrequired`)
                }]
            }]
        });
        
        return (
            <div>
                <div onClick={this.onChange.bind(this)}>
                    <input 
                        className='date-time-picker' 
                        placeholder={$st('选择日期')}
                        readOnly 
                        value={defaultValue}/>
                </div>
                {(errorText && !defaultValue) && <div className='input-error'>{errorText}</div>}
            </div>
        )
    }
}

export default WrapComponent(DateIndex);


// WEBPACK FOOTER //
// ./src/form/date.js